import styled from 'styled-components';

import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';
import { wideBreakpoints } from '../wideContainer';

export const Wrapper = styled.div<{ bgImage: string }>`
    position: relative;
    background-color: ${COLORS.BgError};
    background-image: url(${({ bgImage }) => bgImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center 22%;
    width: 100%;
    height: 100%;
    white-space: pre-line;
   
    &:after {
        position: absolute;
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(4, 6, 15, 0.15) 17.92%, rgba(4, 6, 15, 0.9) 91.6%);
        z-index: 0;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        background-position-y: 13%;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        background-position-y: 27%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        background-position-y: 114%;
        background-size: auto 107%;
    }
`;

export const Inner = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    color: ${COLORS.TextWhite};
    width: 100%;
    height: 100%;
    min-height: 100vh;
    padding: 0 22px 22px 22px;
    z-index: 1;

    @media (min-width: 1921px) {
        justify-content: center;
    }
`;

export const Logo = styled.img`
    margin-top: 128px;
    width: 97px;
    height: 33px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 60px;
        width: 63px;
        height: 21px;
    }
`;

export const ErrorCode = styled.p`
    ${FONTS.H0};
    font-size: 260px;
    letter-spacing: 0.01em;
    line-height: 181px;
    height: 182px;
    margin: 150px 0 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        font-size: 100px;
        line-height: 84px;
        height: 85px;
        margin: 156px 0 0;
    }

    @media (max-width: 320px) {
        margin: 66px 0 0;
    }
`;

export const Title = styled.h1`
    ${FONTS.H1};
    margin: 70px 0 0;
    text-align: center;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
        margin: 66px 0 0;
    }

    @media (max-width: 320px) {
        margin: 36px 0 0;
    }
`;

export const Text = styled.p`
    ${FONTS.M};
    margin: 8px 0 0;
    text-align: center;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
        white-space: initial;
        margin: 22px 0 0;
    }
`;

export const Navbar = styled.ul`
    display: flex;
    padding: 0;
    list-style: none;
    margin: 24px 0;
`;

export const NavItem = styled.li`
    margin-right: 24px;

    &:last-child {
        margin-right: 0;
    }

    a {
        ${FONTS.MediumS};
        color: ${COLORS.TextWhite};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }
`;

